const WhatsAppChatIcon = ({ width = '16', height = '16', fill = '#E4F8ED' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 0C3.589 0 0 3.589 0 8C0 9.408 0.374 10.73 1.027 11.875L0.051 15.215C-0.034 15.502 0.239 15.771 0.524 15.682L3.792 14.647C4.963 15.333 6.435 15.75 8 15.75C12.411 15.75 16 12.161 16 7.75C16 3.339 12.411 0 8 0ZM11.75 10.625C11.596 11.012 10.972 11.337 10.536 11.417C10.229 11.473 9.832 11.517 8.453 10.951C6.694 10.233 5.56 8.447 5.473 8.332C5.389 8.218 4.75 7.371 4.75 6.494C4.75 5.617 5.198 5.19 5.369 5.013C5.511 4.865 5.746 4.797 5.971 4.797C6.044 4.797 6.11 4.801 6.169 4.804C6.34 4.811 6.427 4.821 6.54 5.092C6.682 5.43 7.017 6.307 7.057 6.394C7.098 6.481 7.139 6.598 7.08 6.713C7.025 6.831 6.976 6.884 6.889 6.985C6.802 7.086 6.72 7.163 6.633 7.271C6.554 7.365 6.466 7.466 6.566 7.637C6.666 7.804 7.013 8.368 7.523 8.823C8.181 9.412 8.715 9.604 8.905 9.683C9.048 9.742 9.218 9.728 9.322 9.616C9.454 9.473 9.617 9.237 9.783 9.004C9.903 8.836 10.053 8.815 10.211 8.874C10.372 8.93 11.245 9.362 11.42 9.448C11.595 9.535 11.711 9.576 11.752 9.649C11.793 9.722 11.793 10.058 11.75 10.625Z"
        fill={fill}
      />
    </svg>
  )
}

export default WhatsAppChatIcon
